"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBeerGlassOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M11.988 12.564h1v6h-1v-6zM8.99 16.564h1v2h-1v-2z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.011 10c-.5-.5-1.103-1.773-1-3 .099-1.161 1.12-2.617 2.998-3 0 0 1.344-2 3.998-2 2.653 0 3.997 2 3.997 2s2.998.552 2.998 3.5c0 1.5-1 2.5-1 2.5v1h1S20 11 20 13v2c0 3.5-2.998 4-2.998 4v1c0 2-1.998 2-1.998 2H7.009s-1.998 0-1.998-2V10zm1.09-1.991c-.128-.388-.197-.975.314-1.52C7.06 5.8 7.821 6 8.133 6.124c.273-.734 1-2.121 2.873-2.121 1.823 0 2.641 1.423 2.889 2.108.319-.1 1.149-.156 1.647.298.498.454.527 1.14.369 1.599 0 0-3.215-.009-5.915-.009-1 0-.983 1-.983 1v3.034s0 .966-1.016.966-.996-.966-.996-.966V9s0-1-.9-.991zM16.991 17c.5 0 .999-.5.999-1v-3h-1v4zm-8.994-2h-1v5h7.995V10h-3.997v2c0 1.657-1.342 3-2.998 3z' }))); };
exports.default = SvgBeerGlassOutline;
//# sourceMappingURL=BeerGlassOutline.js.map